export const DEMAND = {
    TP_PLD: 'TP_PLD',
    TP_N_PLD: 'TP_N_PLD',
    TP_GED: 'TP_GED',
    UIM_PLD: 'UIM_PLD',
    UIM_N_PLD: 'UIM_N_PLD',
    UM_PLD: 'UM_PLD',
    UM_N_PLD: 'UM_N_PLD',
    Simplified_TP_PLD: 'Simplified_TP_PLD',
    Simplified_UIM_PLD: 'Simplified_UIM_PLD',
    Simplified_UM_PLD: 'Simplified_UM_PLD',
    Medical_Chronology: 'Medical_Chronology',
    Lifecare_Plan: "Lifecare_Plan",
    Certified_Lifecare_Plan: "Preliminary_Lifecare_Plan",
    Silent_Witness: 'Silent_Witness'
};

export const DEMAND_TYPE = {
    [DEMAND.TP_PLD]: { key: 'thirdPartyPolicyLimit', text: 'Third Party Policy Limit Demand', value: DEMAND.TP_PLD, alias: '3P_PLD' },
    [DEMAND.TP_N_PLD]: { key: 'thirdPartyNonPolicyLimit', text: 'Third Party Non-Policy Limit Demand', value: DEMAND.TP_N_PLD, alias: '3P_N_PLD' },
    [DEMAND.TP_GED]: { key: 'tp_ged', text: 'Third Party Government Entity Demand', value: DEMAND.TP_GED, alias: '3P_GED' },
    [DEMAND.UIM_PLD]: { key: 'uimPolicyLimitDemand', text: 'UIM Policy Limit Demand', value: DEMAND.UIM_PLD, alias: 'UIM_PLD' },
    [DEMAND.UIM_N_PLD]: { key: 'uimNonPolicyLimitDemand', text: 'UIM Non-Policy Limit Demand', value: DEMAND.UIM_N_PLD, alias: 'UIM_N_PLD' },
    [DEMAND.UM_PLD]: { key: 'um_pld', text: 'UM Policy Limit Demand', value: DEMAND.UM_PLD, alias: 'UM_PLD' },
    [DEMAND.UM_N_PLD]: { key: 'um_n_pld', text: 'UM Non-Policy Limit Demand', value: DEMAND.UM_N_PLD, alias: 'UM_N_PLD' },
    [DEMAND.Simplified_TP_PLD]: { key: 'simplified_tp_pld', text: 'Simplified Third Party Policy Limit Demand', value: DEMAND.Simplified_TP_PLD, alias: 'Simplified_3P_PLD' },
    [DEMAND.Simplified_UIM_PLD]: { key: 'simplified_uim_pld', text: 'Simplified UIM Policy Limit Demand', value: DEMAND.Simplified_UIM_PLD, alias: 'Simplified_UIM_PLD' },
    [DEMAND.Simplified_UM_PLD]: { key: 'simplified_um_pld', text: 'Simplified UM Policy Limit Demand', value: DEMAND.Simplified_UM_PLD, alias: 'Simplified_UM_PLD' },
    [DEMAND.Medical_Chronology]: { key: 'medical_chronology', text: 'Medical Chronology', value: DEMAND.Medical_Chronology, alias: 'Medical_Chronology' },
    [DEMAND.Lifecare_Plan]: { key: 'lifecare_plan', text: 'Future Cost Projection', value: DEMAND.Lifecare_Plan, alias: 'Cost_Projection' },
    [DEMAND.Certified_Lifecare_Plan]: { key: 'certifiedLifecare', text: 'Preliminary Life Care Plan', value: DEMAND.Certified_Lifecare_Plan, alias: 'Certified_Lifecare_Plan' },
    [DEMAND.Silent_Witness]: { key: 'silent_witness', text: 'Silent Witness', value: DEMAND.Silent_Witness, alias: 'Silent_Witness' }
};

export const NOTIFICATION_TYPE = {
  DEMAND_READY: 'DEMAND_READY',
  NOTE_ADDED : 'NOTE_ADDED',
  INVOICE_MAIL_SENT: 'INVOICE_MAIL_SENT',
  INVOICE_MAIL_FAILED: 'INVOICE_MAIL_FAILED',
  REGENERATION_FAILED: 'REGENERATION_FAILED'
}

export const INTEGRATION_PARTNER = {
    CASEPEER: 'casepeer',
    CHARTSQUAD: 'chartSquad',
    SMARTADVOCATE: 'smartAdvocate'
};

export const SINGLE_API_KEY_PARTNERS = [
    INTEGRATION_PARTNER.CASEPEER
];

export const COMPANY_LEVEL_KEY_PARTNERS = [
    INTEGRATION_PARTNER.SMARTADVOCATE
];

export const INTEGRATION_PARTNER_MAP = {
    [INTEGRATION_PARTNER.CASEPEER]: {
        key: 'casepeer',
        text: 'CASEPEER',
        value: INTEGRATION_PARTNER.CASEPEER,
    },
    [INTEGRATION_PARTNER.CHARTSQUAD]: {
        key: 'chartSquad',
        text: 'Chart Squad',
        isSecretKey: true,
        value: INTEGRATION_PARTNER.CHARTSQUAD,
        baseURL: 'https://api.chartsquad.com/v2'
    },
    [INTEGRATION_PARTNER.SMARTADVOCATE]: {
        key: 'smartAdvocate',
        text: 'Smart Advocate',
        isSecretKey: true,
        value: INTEGRATION_PARTNER.SMARTADVOCATE,
        baseURL: 'https://app.smartadvocate.com/CaseSyncAPI'
    }
};

export const CASE_TYPE = {
    AUTO_ACCIDENT: 'AUTO_ACCIDENT',
    TRIP_AND_FALL: 'TRIP_AND_FALL',
    SLIP_AND_FALL: 'SLIP_AND_FALL',
    PREMISE_LIABILITY: 'PREMISE_LIABILITY',
    //PRODUCT_LIABILITY: 'PRODUCT_LIABILITY',
    DOG_BITE: 'DOG_BITE',
}

export const CASE_TYPE_MAP = {
    [CASE_TYPE.AUTO_ACCIDENT]: { key: 'auto_accident', text: 'Auto Accident', value: CASE_TYPE.AUTO_ACCIDENT },
    [CASE_TYPE.TRIP_AND_FALL]: { key: 'trip_and_fall', text: 'Trip and Fall', value: CASE_TYPE.TRIP_AND_FALL },
    [CASE_TYPE.SLIP_AND_FALL]: { key: 'slip_and_fall', text: 'Slip and Fall', value: CASE_TYPE.SLIP_AND_FALL },
    [CASE_TYPE.PREMISE_LIABILITY]: { key: 'premise_liability', text: 'Premise Liability', value: CASE_TYPE.PREMISE_LIABILITY },
    // [CASE_TYPE.PRODUCT_LIABILITY]: { key: 'product_liability', text: 'Product Liability', value: CASE_TYPE.PRODUCT_LIABILITY },
    [CASE_TYPE.DOG_BITE]: { key: 'dog_bite', text: 'Dog Bite', value: CASE_TYPE.DOG_BITE },
};

export const CASE_TYPE_DEMANDS = {
    [CASE_TYPE.AUTO_ACCIDENT]: [
        DEMAND.TP_PLD,
        DEMAND.TP_N_PLD,
        DEMAND.TP_GED,
        DEMAND.UIM_PLD,
        DEMAND.UIM_N_PLD,
        DEMAND.UM_PLD,
        DEMAND.UM_N_PLD,
        DEMAND.Simplified_TP_PLD,
        DEMAND.Simplified_UIM_PLD,
        DEMAND.Simplified_UM_PLD,
        DEMAND.Medical_Chronology,
        DEMAND.Lifecare_Plan,
        DEMAND.Certified_Lifecare_Plan
    ],

    [CASE_TYPE.TRIP_AND_FALL]: [
        DEMAND.TP_PLD,
        DEMAND.TP_N_PLD,
        DEMAND.TP_GED,
        DEMAND.Simplified_TP_PLD,
        DEMAND.Medical_Chronology,
        DEMAND.Lifecare_Plan,
        DEMAND.Certified_Lifecare_Plan
    ],

    [CASE_TYPE.SLIP_AND_FALL]: [
        DEMAND.TP_PLD,
        DEMAND.TP_N_PLD,
        DEMAND.TP_GED,
        DEMAND.Simplified_TP_PLD,
        DEMAND.Medical_Chronology,
        DEMAND.Lifecare_Plan,
        DEMAND.Certified_Lifecare_Plan
    ],

    [CASE_TYPE.PREMISE_LIABILITY]: [
        DEMAND.TP_PLD,
        DEMAND.TP_N_PLD,
        DEMAND.TP_GED,
        DEMAND.Simplified_TP_PLD,
        DEMAND.Medical_Chronology,
        DEMAND.Lifecare_Plan,
        DEMAND.Certified_Lifecare_Plan
    ],

    // [CASE_TYPE.PRODUCT_LIABILITY]: [
    //     DEMAND.TP_PLD,
    //     DEMAND.TP_N_PLD,
    //     DEMAND.TP_GED,
    //     DEMAND.Simplified_TP_PLD,
    //     DEMAND.Medical_Chronology
    // ],

    [CASE_TYPE.DOG_BITE]: [
        DEMAND.TP_PLD,
        DEMAND.TP_N_PLD,
        DEMAND.TP_GED,
        DEMAND_TYPE.Simplified_TP_PLD.value,
        DEMAND.Medical_Chronology,
        DEMAND.Lifecare_Plan,
        DEMAND.Certified_Lifecare_Plan
    ]

};

export const DEMAND_GROUP = {
    TP: [DEMAND.TP_PLD, DEMAND.TP_N_PLD, DEMAND.Simplified_TP_PLD, DEMAND.TP_GED],
    UIM: [DEMAND.UIM_PLD, DEMAND.UIM_N_PLD, DEMAND.Simplified_UIM_PLD],
    UM: [DEMAND.UM_PLD, DEMAND.UM_N_PLD, DEMAND.Simplified_UM_PLD],
    PLD: [DEMAND.TP_PLD, DEMAND.UIM_PLD, DEMAND.UM_PLD],
    NON_PLD: [DEMAND.TP_N_PLD, DEMAND.UIM_N_PLD, DEMAND.UM_N_PLD],
    SIMPLIFIED: [DEMAND.Simplified_TP_PLD, DEMAND.Simplified_UIM_PLD, DEMAND.Simplified_UM_PLD],
    REGULAR: [DEMAND.TP_PLD, DEMAND.TP_N_PLD, DEMAND.UIM_PLD, DEMAND.UIM_N_PLD, DEMAND.UM_PLD, DEMAND.UM_N_PLD],
    ALL: Object.values(DEMAND)
}

export const LIABILITY_FILES_KEY = {
    POLICE_REPORT_DATA: 'policeReportData',
    WITNESS_STATEMENT: 'witnessStatements',
    INCIDENT_REPORT: 'incidentReports',
    EXPERT_SAFETY_REPORT: 'expertSafetyReport',
}

export const BUTTON_TYPES = {
    PRIMARY: 'primary',
    LINK: 'link'
};

export const STATES = [
    { value: 'California', text: 'California' },
    { value: 'Alabama', text: 'Alabama' },
    { value: 'Alaska', text: 'Alaska' },
    { value: 'Arizona', text: 'Arizona' },
    { value: 'Arkansas', text: 'Arkansas' },
    { value: 'Colorado', text: 'Colorado' },
    { value: 'Connecticut', text: 'Connecticut' },
    { value: 'Delaware', text: 'Delaware' },
    { value: 'District of Columbia', text: 'District of Columbia' },
    { value: 'Florida', text: 'Florida' },
    { value: 'Georgia', text: 'Georgia' },
    { value: 'Hawaii', text: 'Hawaii' },
    { value: 'Idaho', text: 'Idaho' },
    { value: 'Illinois', text: 'Illinois' },
    { value: 'Indiana', text: 'Indiana' },
    { value: 'Iowa', text: 'Iowa' },
    { value: 'Kansas', text: 'Kansas' },
    { value: 'Kentucky', text: 'Kentucky' },
    { value: 'Louisiana', text: 'Louisiana' },
    { value: 'Maine', text: 'Maine' },
    { value: 'Maryland', text: 'Maryland' },
    { value: 'Massachusetts', text: 'Massachusetts' },
    { value: 'Michigan', text: 'Michigan' },
    { value: 'Minnesota', text: 'Minnesota' },
    { value: 'Mississippi', text: 'Mississippi' },
    { value: 'Missouri', text: 'Missouri' },
    { value: 'Montana', text: 'Montana' },
    { value: 'Nebraska', text: 'Nebraska' },
    { value: 'Nevada', text: 'Nevada' },
    { value: 'New Hampshire', text: 'New Hampshire' },
    { value: 'New Jersey', text: 'New Jersey' },
    { value: 'New Mexico', text: 'New Mexico' },
    { value: 'New York', text: 'New York' },
    { value: 'North Carolina', text: 'North Carolina' },
    { value: 'North Dakota', text: 'North Dakota' },
    { value: 'Ohio', text: 'Ohio' },
    { value: 'Oklahoma', text: 'Oklahoma' },
    { value: 'Oregon', text: 'Oregon' },
    { value: 'Pennsylvania', text: 'Pennsylvania' },
    { value: 'Rhode Island', text: 'Rhode Island' },
    { value: 'South Carolina', text: 'South Carolina' },
    { value: 'South Dakota', text: 'South Dakota' },
    { value: 'Tennessee', text: 'Tennessee' },
    { value: 'Texas', text: 'Texas' },
    { value: 'Utah', text: 'Utah' },
    { value: 'Vermont', text: 'Vermont' },
    { value: 'Virginia', text: 'Virginia' },
    { value: 'Washington', text: 'Washington' },
    { value: 'West Virginia', text: 'West Virginia' },
    { value: 'Wisconsin', text: 'Wisconsin' },
    { value: 'Wyoming', text: 'Wyoming' }
];

export const CREATE_REQUEST_STATUS = {
  PENDING: 'PENDING',
  DEFERRED: 'DEFERRED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  BAD_RECORD : 'BAD_RECORD'
};

export const FINALIZATION_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

// studio-facing status of a single suggested edit section
export const SECTION_UI_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'success',
  FAILED: 'failed'
};

export const REQUEST_TYPES = {
  DEMAND: 'DEMAND',
  MEDICAL_SUMMARY: 'MEDICAL_SUMMARY',
  SUGGESTED_EDIT: 'SUGGESTED_EDIT',
  SILENT_WITNESS: 'SILENT_WITNESS',
  SILENT_WITNESS_REPORT: 'SILENT_WITNESS_REPORT',
  MANUAL_EDIT: 'MANUAL_EDIT',
  UNDO: 'UNDO',
  REDO: 'REDO',
  CERTIFIED_LIFECARE_ASSIGNMENT: 'CERTIFIED_LIFECARE_ASSIGNMENT',
  CERTIFIED_LIFECARE_FINALIZE: 'CERTIFIED_LIFECARE_FINALIZE',
  VIRTUAL_USER: 'VIRTUAL_USER',
  DISCOVERY_SET_PROCESSING: 'DISCOVERY_SET_PROCESSING'
};

// Stages of one Easy Mode virtual-user run, carried on the request document and the socket payloads
export const VIRTUAL_USER_STAGE = {
  CLASSIFYING_RECORDS: 'CLASSIFYING_RECORDS',
  RESOLVING_PARTIES: 'RESOLVING_PARTIES',
  ASSIGNING_LIABILITY: 'ASSIGNING_LIABILITY',
  WRITING_LIABILITY_NARRATIVE: 'WRITING_LIABILITY_NARRATIVE',
  ASSIGNING_IMAGES: 'ASSIGNING_IMAGES',
  ASSIGNING_MEDICAL: 'ASSIGNING_MEDICAL',
  NAMING_PROVIDERS: 'NAMING_PROVIDERS',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED'
};

// The wizard's three steps. Lives here rather than in the UI because a gap report row names the step
// a human has to return to, and the agent that builds it runs in the PFQ.
export const EASY_MODE_STEP = {
    CASE_INTAKE: 1,
    DOCUMENT_UPLOAD: 2,
    DEMAND_GENERATION: 3
};

export const VIRTUAL_USER_GAP_SEVERITY = {
    // the run refuses to chain a demand while one of these stands
    BLOCKING: 'blocking',
    WARNING: 'warning',
    INFO: 'info'
};

// errorlog codes for a virtual-user run, so a human can query the collection for what a run recorded
export const VIRTUAL_USER_ERROR_CODE = {
    RUN_DIAGNOSTICS: 'VIRTUAL_USER_RUN_DIAGNOSTICS',
    RUN_FAILED: 'VIRTUAL_USER_RUN_FAILED'
};

// Codes rather than free strings so a consumer can map a row to a navigation target
export const VIRTUAL_USER_GAP_CODE = {
    UNRECOGNIZED_DOCUMENTS: 'UNRECOGNIZED_DOCUMENTS',
    PARTY_COUNT_MISMATCH: 'PARTY_COUNT_MISMATCH',
    CLIENT_NAME_MISSING: 'CLIENT_NAME_MISSING',
    DATE_OF_INCIDENT_INVALID: 'DATE_OF_INCIDENT_INVALID',
    LIABILITY_DOCUMENT_UNPLACED: 'LIABILITY_DOCUMENT_UNPLACED',
    NO_LIABILITY_EVIDENCE: 'NO_LIABILITY_EVIDENCE',
    NO_POST_INCIDENT_MEDICAL: 'NO_POST_INCIDENT_MEDICAL',
    PROVIDER_NAMES_UNRESOLVED: 'PROVIDER_NAMES_UNRESOLVED',
    NO_LIABILITY_NARRATIVE: 'NO_LIABILITY_NARRATIVE',
    DEFENDANT_COVERAGE_MISSING: 'DEFENDANT_COVERAGE_MISSING'
};

export const LIFECARE_REQUEST_TYPES = {
  SUBMITTED: 'SUBMITTED',
  RE_SUBMITTED: 'RE_SUBMITTED'
};

// result of a lifecare plan generation attempt; absent on a doc means not yet processed
export const LIFECARE_PLAN_GENERATION_STATUS = {
  GENERATED: 'GENERATED',
  NO_DATA: 'NO_DATA',
  FAILED: 'FAILED',
  // toggle was off at generation time: intentionally not generated, distinct from "ran but found nothing"
  NOT_REQUESTED: 'NOT_REQUESTED'
};

export const REQUEST_TYPES_THAT_CAN_BE_UNDONE = [
    REQUEST_TYPES.SUGGESTED_EDIT,
    REQUEST_TYPES.MANUAL_EDIT,
    REQUEST_TYPES.UNDO,
    REQUEST_TYPES.REDO
];

export const MEDICAL_PROVIDER_INPUT_MODE = {
  AI: 'AI',
  MANUAL: 'MANUAL'
};

// tasks that run independently and must not kill the active DEMAND/MEDICAL_SUMMARY job
export const INDEPENDENT_REQUEST_TYPES = new Set([
  REQUEST_TYPES.SUGGESTED_EDIT,
  REQUEST_TYPES.SILENT_WITNESS,
  REQUEST_TYPES.DISCOVERY_SET_PROCESSING
]);

export const SW_ANALYSIS_TYPE = {
  ACCIDENT_ONLY: 'accident_only',
  ACCIDENT_INJURY: 'accident_injury'
};

export const SW_ANALYSIS_TYPES_REQUIRING_OCCUPANTS = new Set([
  SW_ANALYSIS_TYPE.ACCIDENT_INJURY
]);

export const SW_ANALYSIS_TYPE_MAP = {
  [SW_ANALYSIS_TYPE.ACCIDENT_ONLY]: { value: SW_ANALYSIS_TYPE.ACCIDENT_ONLY, text: 'Accident only (no biomechanics)' },
  [SW_ANALYSIS_TYPE.ACCIDENT_INJURY]: { value: SW_ANALYSIS_TYPE.ACCIDENT_INJURY, text: 'Accident + Injury (biomechanics)' }
};

export const SW_OCCUPANT_POSITION = {
  DRIVER: 'driver',
  FRONT_PASSENGER: 'front_passenger',
  REAR_LEFT: 'rear_left',
  REAR_CENTER: 'rear_center',
  REAR_RIGHT: 'rear_right'
};

export const SW_OCCUPANT_POSITION_MAP = {
  [SW_OCCUPANT_POSITION.DRIVER]: { value: SW_OCCUPANT_POSITION.DRIVER, text: 'Driver' },
  [SW_OCCUPANT_POSITION.FRONT_PASSENGER]: { value: SW_OCCUPANT_POSITION.FRONT_PASSENGER, text: 'Front passenger' },
  [SW_OCCUPANT_POSITION.REAR_LEFT]: { value: SW_OCCUPANT_POSITION.REAR_LEFT, text: 'Rear left' },
  [SW_OCCUPANT_POSITION.REAR_CENTER]: { value: SW_OCCUPANT_POSITION.REAR_CENTER, text: 'Rear center' },
  [SW_OCCUPANT_POSITION.REAR_RIGHT]: { value: SW_OCCUPANT_POSITION.REAR_RIGHT, text: 'Rear right' }
};

export const GENDER = {
  MALE: 'male',
  FEMALE: 'female'
};

export const POSSESSIVE_PRONOUN = {
  MALE: 'his',
  FEMALE: 'her',
  NEUTRAL: 'their'
};

export const SUBJECT_PRONOUN = {
  MALE: 'he',
  FEMALE: 'she',
  NEUTRAL: 'they'
};

export const OBJECT_PRONOUN = {
  MALE: 'him',
  FEMALE: 'her',
  NEUTRAL: 'them'
};

export const SW_AIRBAG_DEPLOYED = {
  YES: 'yes',
  NO: 'no',
  PARTIAL: 'partial',
  UNKNOWN: 'unknown'
};

export const CHAT_AUTHOR = {
  USER: 'user',
  ASSISTANT: 'assistant'
};

export const textAlignOptions = [
  { key: "left", value: "LEFT", text: "Left" },
  { key: "center", value: "CENTER", text: "Center" },
  { key: "right", value: "RIGHT", text: "Right" },
  { key: "justified", value: "JUSTIFIED", text: "Justified" }
];

export const UPDATE_CASE_ACTION = {
  UPDATE: 'update',
  UPDATE_BY_ID: 'updateById',
  ADD: 'add',
  REMOVE: 'remove',
  ADD_UNIQUE: 'addUnique'
};

export const COMPANY_TIER = {
    DIAMOND: 'Diamond',
    GOLD: 'Gold',
    SILVER: 'Silver',
    PLATINIUM: 'Platinium'
};

export const A_LA_CARTE_PRICE = {
    PRELIMINARY_LIFECARE_PLAN: 0.01,
    COST_PROJECTION: {
        [COMPANY_TIER.SILVER]: 0.01,
        [COMPANY_TIER.GOLD]: 0,
        [COMPANY_TIER.PLATINIUM]: 0,
        [COMPANY_TIER.DIAMOND]: 0
    }
};

export const MIGRATION_NAMES = {
  CASE_DATE: 'CASE-DATE', // chnading createdOn updatedOn types
  SETTLED_AMOUNT: 'SETTLED-AMOUNT', // making settledAmount Object
  PLAINTIFF_CREDIT_CHARGE: 'PLAINTIFF-CREDIT-CHARGE', // charge Credit Base on plaintiff
  MULTI_PLAINTIFF : 'MULTI-PLAINTIFF', // update schema to support multi plainTiff
  DEDICATED_FILE: 'DEDICATED-FILE',
  USER_RECORD_LOWER_CASE: 'USER-RECORD-LOWER-CASE',// User recods (email) to lower case
  USER_API_KEYS: 'USER-API-KEYS', // for internal and external api's
  TEMPLATE_BUILDER: 'TEMPLATE-BUILDER',
  MIGRATE_CASE: 'MIGRATE-CASE',
  CASE_PROCESS_COUNT: 'CASE-PROCESS-COUNT',
  CASE_PROCESS_TIME: 'CASE-PROCESS-TIME',
  ACCOUNT_EMAIL: 'ACCOUNT-EMAIL',
  COMPANY_TIER: 'COMPANY-TIER',
  DOCX_DOWNLOADS_INIT: 'DOCX-DOWNLOADS-INIT', // Initialize docxFiles.downloads field
  COMPANY_STATUS: 'COMPANY-STATUS', // Remove isTrail and add status and lastStatusUpdatedOn
  PAIN_AND_SUFFERING_VALUES: 'PAIN_AND_SUFFERING_VALUES',
  ANNUAL_TARGET:'ANNUAL_TARGET',
  CREATE_REQUEST: 'CREATE_REQUEST',
  ERROR_LOGS_AND_AI_USAGE: 'ERROR_LOGS_AND_AI_USAGE', // converting string Id to object Id
  FORM_INTERROGATORY: 'FORM_INTERROGATORY', // seed california form interrogatory master questions
  SNAPSHOT: 'SNAPSHOT', // snapshot case data on most recent completed create request per case
};

export const COMPANY_STATUS = {
    TRIAL: 'TRIAL',
    ALACARTE: 'ALACARTE',
    SUBSCRIBED: 'SUBSCRIBED',
    CANCELED: 'CANCELED',
    PLANNER: 'PLANNER'
};

export const COMPANY_HEALTH = {
    HEALTHY: 'Healthy',
    AT_RISK: 'At Risk',
    CRITICAL: 'Critical',
};

export const COMPANY_STATUS_MAP = {
    [COMPANY_STATUS.TRIAL]: { text: 'Trial', value: COMPANY_STATUS.TRIAL },
    [COMPANY_STATUS.ALACARTE]: { text: 'Alacarte', value: COMPANY_STATUS.ALACARTE },
    [COMPANY_STATUS.SUBSCRIBED]: { text: 'Subscribed', value: COMPANY_STATUS.SUBSCRIBED },
    [COMPANY_STATUS.CANCELED]: { text: 'Canceled', value: COMPANY_STATUS.CANCELED },
    [COMPANY_STATUS.PLANNER]: { text: 'Planner', value: COMPANY_STATUS.PLANNER }
};

export const DATE_INTERVAL = {
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly'
};

export const CSV_DATA_TYPE = {
    COMPANIES_FULL_DATA: 'COMPANIES_FULL_DATA',
    EXCEEDING_CREDITS: 'EXCEEDING_CREDITS',
    INACTIVE_CUSTOMERS: 'INACTIVE_CUSTOMERS',
    OVER_USAGE_DEMAND: 'OVER_USAGE_DEMAND',
    HEALTH_OVERVIEW: 'HEALTH_OVERVIEW',
};

export const RECORD_DATA_TYPE = {
    POLICE: 'POLICE',
    LIABILITY: 'LIABILITY',
    MEDICAL: 'MEDICAL',
    FUTURE: 'FUTURE',
    INCOME_LOSS: 'INCOME_LOSS',
    IMAGE: 'IMAGE',
    LETTER_OF_PROTECTION: 'LETTER_OF_PROTECTION',
    CERTIFIED_LIFECARE_PLAN: 'CERTIFIED_LIFECARE_PLAN',
    CURRICULUM_VITAE: 'CURRICULUM_VITAE',
    FROG: 'FROG',
    SROG: 'SROG',
    DOCUMENT: 'DOCUMENT',
    ADMISSION: 'ADMISSION',
    LIFE_CARE_PLAN_SUPPORTING_DOCUMENT: 'LIFE_CARE_PLAN_SUPPORTING_DOCUMENT',
    OPPOSING_DISCOVERY: 'OPPOSING_DISCOVERY',
    DEPOSITION_DOC:'DEPOSITION_DOC',
    PLANNER_SIGNATURE: 'PLANNER_SIGNATURE',
    CLIENT_INTAKE: 'CLIENT_INTAKE',
    AUTO_IMAGE: 'AUTO_IMAGE',
    INJURY_IMAGE: 'INJURY_IMAGE',
    OTHER_IMAGE: 'OTHER_IMAGE',
    UNCLASSIFIED: 'UNCLASSIFIED',
    DISCOVERY_EXHIBIT: 'DISCOVERY_EXHIBIT',
    DIFFERENTIAL_DIAGNOSIS: 'DIFFERENTIAL_DIAGNOSIS',
    OTHER: 'OTHER'
};

export const RECORD_DATA_TYPE_DESCRIPTION = {
    [RECORD_DATA_TYPE.POLICE]: 'A police or traffic collision report prepared by a law enforcement agency about the incident.',
    [RECORD_DATA_TYPE.LIABILITY]: 'A document establishing who is at fault - an incident report, witness statement, or expert safety report - that is not a police report.',
    [RECORD_DATA_TYPE.MEDICAL]: 'Anything a provider produced about treatment: chart notes, imaging reports, operative reports, therapy notes, discharge summaries, and also bills, invoices, statements or ledgers charging for that treatment.',
    [RECORD_DATA_TYPE.FUTURE]: 'A projection of medical care and cost the plaintiff still needs, such as a future care plan or surgical cost estimate.',
    [RECORD_DATA_TYPE.INCOME_LOSS]: 'Proof of lost earnings: pay stubs, employer wage letters, tax returns, or a self-employment income statement.',
    [RECORD_DATA_TYPE.CLIENT_INTAKE]: 'A form the firm collected from its own client capturing their personal details, the incident, and the parties involved.',
    [RECORD_DATA_TYPE.LETTER_OF_PROTECTION]: 'A letter of protection promising a provider payment from the case proceeds.',
    [RECORD_DATA_TYPE.OPPOSING_DISCOVERY]: 'Discovery served by the opposing party: interrogatories, requests for production, or requests for admission.',
    [RECORD_DATA_TYPE.DEPOSITION_DOC]: 'A deposition transcript or errata sheet.',
    [RECORD_DATA_TYPE.AUTO_IMAGE]: 'A photograph of a vehicle, the roadway, or the incident scene.',
    [RECORD_DATA_TYPE.INJURY_IMAGE]: 'A photograph of a person\'s injuries.',
    [RECORD_DATA_TYPE.OTHER_IMAGE]: 'A photograph that shows neither a vehicle or scene nor an injury.',
    [RECORD_DATA_TYPE.OTHER]: 'A document that does not belong to any of the other types.'
};

export const RECORD_DATA_TYPE_LABEL = {
    [RECORD_DATA_TYPE.POLICE]: 'Police report',
    [RECORD_DATA_TYPE.LIABILITY]: 'Liability',
    [RECORD_DATA_TYPE.MEDICAL]: 'Medical record',
    [RECORD_DATA_TYPE.FUTURE]: 'Future medical',
    [RECORD_DATA_TYPE.INCOME_LOSS]: 'Income loss',
    [RECORD_DATA_TYPE.CLIENT_INTAKE]: 'Client intake',
    [RECORD_DATA_TYPE.LETTER_OF_PROTECTION]: 'Letter of protection',
    [RECORD_DATA_TYPE.OPPOSING_DISCOVERY]: 'Opposing discovery',
    [RECORD_DATA_TYPE.DEPOSITION_DOC]: 'Deposition',
    [RECORD_DATA_TYPE.CERTIFIED_LIFECARE_PLAN]: 'Life care plan',
    [RECORD_DATA_TYPE.LIFE_CARE_PLAN_SUPPORTING_DOCUMENT]: 'Life care plan support',
    [RECORD_DATA_TYPE.CURRICULUM_VITAE]: 'Curriculum vitae',
    [RECORD_DATA_TYPE.PLANNER_SIGNATURE]: 'Signature',
    [RECORD_DATA_TYPE.IMAGE]: 'Photograph',
    [RECORD_DATA_TYPE.AUTO_IMAGE]: 'Photograph',
    [RECORD_DATA_TYPE.INJURY_IMAGE]: 'Photograph',
    [RECORD_DATA_TYPE.OTHER_IMAGE]: 'Photograph',
    [RECORD_DATA_TYPE.OTHER]: 'Unrecognized'
};

export const IMAGE_RECORD_TYPES = new Set([
    RECORD_DATA_TYPE.IMAGE,
    RECORD_DATA_TYPE.AUTO_IMAGE,
    RECORD_DATA_TYPE.INJURY_IMAGE,
    RECORD_DATA_TYPE.OTHER_IMAGE
]);

export const UNRESOLVED_RECORD_TYPES = new Set([
    RECORD_DATA_TYPE.UNCLASSIFIED,
    RECORD_DATA_TYPE.OTHER
]);

export const CLASSIFIABLE_RECORD_TYPES = [
    RECORD_DATA_TYPE.POLICE,
    RECORD_DATA_TYPE.LIABILITY,
    RECORD_DATA_TYPE.MEDICAL,
    RECORD_DATA_TYPE.FUTURE,
    RECORD_DATA_TYPE.INCOME_LOSS,
    RECORD_DATA_TYPE.CLIENT_INTAKE,
    RECORD_DATA_TYPE.LETTER_OF_PROTECTION,
    RECORD_DATA_TYPE.OPPOSING_DISCOVERY,
    RECORD_DATA_TYPE.DEPOSITION_DOC,
    RECORD_DATA_TYPE.OTHER
];

export const SIGNATURE_LIMITS = {
    MIME_TYPE: 'image/png',
    MAX_FILE_SIZE_BYTES: 2 * 1024 * 1024,
    MIN_WIDTH_PX: 200,
    MIN_HEIGHT_PX: 60,
    MAX_WIDTH_PX: 1000,
    MAX_HEIGHT_PX: 300
};


export const FILE_EXTENSION = {
    DOC: 'doc',
    DOCX: 'docx',
    PDF: 'pdf',
};

export const DISCOVERY_QUESTION_STATUS = {
    PENDING: 'pending',
    GENERATED: 'generated',
    NEEDS_REVIEW: 'needs_review'
};

export const DISCOVERY_CASE_PART_MAP = {
    LIABILITY: { value: 'liability', description: 'questions about fault, incident details, witnesses, or circumstances of the event' },
    MEDICAL_HISTORY: { value: 'medical history', description: 'questions about post-incident medical treatment, diagnoses, or providers' },
    PRIOR_MEDICAL_HISTORY: { value: 'prior medical history', description: 'questions about pre-existing conditions or treatment before the incident' },
    PAIN_AND_SUFFERING: { value: 'pain and suffering', description: 'questions about physical pain, emotional distress, or quality of life impact' },
    NON_ECONOMIC_DAMAGES: { value: 'non economic damages', description: 'questions about loss of enjoyment, consortium, or other non-monetary harm' },
    OTHER: { value: 'other', description: 'questions that do not clearly fit the above categories' }
};

export const DISCOVERY_CASE_PART = Object.fromEntries(
    Object.entries(DISCOVERY_CASE_PART_MAP).map(([key, entry]) => [key, entry.value])
);

export const DISCOVERY_SECTION_TYPE_MAP = {
    FORM_INTERROGATORY: { value: 'FORM_INTERROGATORY', text: 'form interrogatory', description: 'standard court-approved numbered interrogatories (e.g. Judicial Council DISC-001)' },
    SPECIAL_INTERROGATORY: { value: 'SPECIAL_INTERROGATORY', text: 'special interrogatory', description: 'custom interrogatories drafted by opposing counsel' },
    REQUEST_FOR_PRODUCTION: { value: 'REQUEST_FOR_PRODUCTION', text: 'request for production', description: 'requests to produce documents, ESI, or tangible things' },
    REQUEST_FOR_ADMISSIONS: { value: 'REQUEST_FOR_ADMISSIONS', text: 'request for admissions', description: 'requests to admit or deny specific facts or legal conclusions' },
};

export const DISCOVERY_SECTION_TYPE = Object.fromEntries(
    Object.entries(DISCOVERY_SECTION_TYPE_MAP).map(([key, entry]) => [key, entry.value])
);

export const FILE_OPTIONS = {
    CASE_FILES: 'caseFiles',
    MEDICAL_CHRONOLOGY: 'Medical_Chronology',
    SILENT_WITNESS: 'Silent_Witness',
}

export const COLLECTION_NAMES = {
    SALES_RECORDS: 'salesrecords',
    DISCOVERY_QUESTIONS: 'discoveryquestions',
    DISCOVERY_TEMPLATES: 'discoverytemplates',
    DISCOVERY_MASTER_QUESTIONS: 'discoverymasterquestions',
    CASES: 'cases',
    DISCOVERY_SETS: 'discoverysets',
    DISCOVERY_SETTING:'discoverysetting',
    COURTS: 'courts',
    CASE_RECORDS: 'records',
    DISCOVERY_OBJECTION_BANK: 'discoveryobjectionbanks',
    CREATE_REQUESTS: 'createrequests',
    DEFINITIONS:'definitions',
    DISCOVERY_PREFERENCES: 'discoverypreferences'
}

export const DEFINITION_ACTION = {
    GET: 'get',
    ADDANDEDIT: 'addAndEdit',
    DELETE: 'delete'
};

export const UPLOAD_PURPOSE = {
    HEADSHOT: 'HEADSHOT',
    CV: 'CV',
    DISCOVERY_TEMPLATE:"DISCOVERY_TEMPLATE",
    PLANNER_SIGNATURE: 'PLANNER_SIGNATURE',
    DISCOVERY_PREFERENCE: 'DISCOVERY_PREFERENCE',
};

export const CLIENT_RESULT_FIELDS = {
    PAIN: `painAndSuffering.result`,
    LIFE: 'result.lifecarePlan',
    DAMAGE: 'damage'
};

export const RECORD_TYPE_PURPOSE = {
    [RECORD_DATA_TYPE.CURRICULUM_VITAE]: UPLOAD_PURPOSE.CV,
    [RECORD_DATA_TYPE.PLANNER_SIGNATURE]: UPLOAD_PURPOSE.PLANNER_SIGNATURE,
};

export const S3_FILE_KIND_BY_EXT = {
    pdf: { ext: 'pdf', contentType: 'application/pdf' },
    zip: { ext: 'zip', contentType: 'application/zip' },
    docx: { ext: 'docx', contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }
};

export const LIABILITY_TEXT_FIELDS_KEY = {
    HOW_INCIDENT_OCCURRED: 'howincidentOccured',
    DANGEROUS_CONDITIONS: 'dangerousConditions',
    FACTS_REGARDING_NOTICE: 'factsRegardingNotice'
}

export const LIABILITY_IMAGE_FILES_KEY = {
    ACCIDENT_SCENE_FILES: 'accidentSceneFiles'
}

export const LIABILITY_FILES_KEY_MAP = {
    [LIABILITY_FILES_KEY.POLICE_REPORT_DATA]: { key: LIABILITY_FILES_KEY.POLICE_REPORT_DATA, text: 'Police Report' },
    [LIABILITY_FILES_KEY.WITNESS_STATEMENT]: { key: LIABILITY_FILES_KEY.WITNESS_STATEMENT, text: 'Witness Statement' },
    [LIABILITY_FILES_KEY.INCIDENT_REPORT]: { key: LIABILITY_FILES_KEY.INCIDENT_REPORT, text: 'Incident Report' },
    [LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT]: { key: LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT, text: 'Expert Safety Report' }
}

// Which liability file sections a case type actually has. Classic Intake renders exactly these
// upload slots, and the virtual user agent builds its tool schema from the same map so the model
// cannot nominate a file into a section the case type does not own.
export const LIABILITY_FILES_KEY_BY_CASE_TYPE = {
    [CASE_TYPE.AUTO_ACCIDENT]: [
        LIABILITY_FILES_KEY.POLICE_REPORT_DATA,
        LIABILITY_FILES_KEY.WITNESS_STATEMENT,
        LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT
    ],
    [CASE_TYPE.TRIP_AND_FALL]: [
        LIABILITY_FILES_KEY.WITNESS_STATEMENT,
        LIABILITY_FILES_KEY.INCIDENT_REPORT,
        LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT
    ],
    [CASE_TYPE.SLIP_AND_FALL]: [
        LIABILITY_FILES_KEY.WITNESS_STATEMENT,
        LIABILITY_FILES_KEY.INCIDENT_REPORT,
        LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT
    ],
    [CASE_TYPE.PREMISE_LIABILITY]: [
        LIABILITY_FILES_KEY.WITNESS_STATEMENT,
        LIABILITY_FILES_KEY.INCIDENT_REPORT,
        LIABILITY_FILES_KEY.EXPERT_SAFETY_REPORT
    ],
    [CASE_TYPE.DOG_BITE]: [
        LIABILITY_FILES_KEY.WITNESS_STATEMENT,
        LIABILITY_FILES_KEY.INCIDENT_REPORT
    ]
};

/**
 * Lists the liability file sections available for a case type.
 * @param {{ caseType: string }} params
 * @returns {string[]} LIABILITY_FILES_KEY values, empty for an unrecognized case type
 */
export const getLiabilityFileKeysForCaseType = ({ caseType }) =>
    LIABILITY_FILES_KEY_BY_CASE_TYPE[caseType] ?? [];

// Every liability section that holds files, irrespective of case type. A partner import files into
// these directly, and it does not consult the case type first - a police report is written to
// policeReportData on a trip and fall too - so anything asking "is this file already on the case"
// has to look wider than the sections the case type owns.
export const ALL_LIABILITY_FILE_KEYS = [
    ...Object.values(LIABILITY_FILES_KEY),
    ...Object.values(LIABILITY_IMAGE_FILES_KEY)
];

// Which liability narrative fields a case type actually has. Classic Intake renders exactly these
// textareas - see useCaseLiabilityTextFields - and the virtual user agent builds its tool schema from
// the same map so the model cannot write a field the case type does not own.
export const LIABILITY_TEXT_FIELDS_KEY_BY_CASE_TYPE = {
    [CASE_TYPE.AUTO_ACCIDENT]: [
        LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED
    ],
    [CASE_TYPE.DOG_BITE]: [
        LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED
    ],
    [CASE_TYPE.TRIP_AND_FALL]: [
        LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED,
        LIABILITY_TEXT_FIELDS_KEY.DANGEROUS_CONDITIONS,
        LIABILITY_TEXT_FIELDS_KEY.FACTS_REGARDING_NOTICE
    ],
    [CASE_TYPE.SLIP_AND_FALL]: [
        LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED,
        LIABILITY_TEXT_FIELDS_KEY.DANGEROUS_CONDITIONS,
        LIABILITY_TEXT_FIELDS_KEY.FACTS_REGARDING_NOTICE
    ],
    [CASE_TYPE.PREMISE_LIABILITY]: [
        LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED,
        LIABILITY_TEXT_FIELDS_KEY.DANGEROUS_CONDITIONS,
        LIABILITY_TEXT_FIELDS_KEY.FACTS_REGARDING_NOTICE
    ]
};

/**
 * Lists the liability narrative fields available for a case type.
 * @param {{ caseType: string }} params
 * @returns {string[]} LIABILITY_TEXT_FIELDS_KEY values, empty for an unrecognized case type
 */
export const getLiabilityTextFieldKeysForCaseType = ({ caseType }) =>
    LIABILITY_TEXT_FIELDS_KEY_BY_CASE_TYPE[caseType] ?? [];

export const LIABILITY_TEXT_FIELDS_KEY_MAP = {
    [LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED]: { key: LIABILITY_TEXT_FIELDS_KEY.HOW_INCIDENT_OCCURRED, text: 'How Incident Occurred' },
    [LIABILITY_TEXT_FIELDS_KEY.DANGEROUS_CONDITIONS]: { key: LIABILITY_TEXT_FIELDS_KEY.DANGEROUS_CONDITIONS, text: 'Dangerous Conditions' },
    [LIABILITY_TEXT_FIELDS_KEY.FACTS_REGARDING_NOTICE]: { key: LIABILITY_TEXT_FIELDS_KEY.FACTS_REGARDING_NOTICE, text: 'Facts Regarding Notice' }
}

export const LIABILITY_IMAGE_FILES_KEY_MAP = {
    [LIABILITY_IMAGE_FILES_KEY.ACCIDENT_SCENE_FILES]: { key: LIABILITY_IMAGE_FILES_KEY.ACCIDENT_SCENE_FILES, text: 'Accident Scene Files' }
}

export const SUGGESTED_EDIT_SECTIONS = {
  EXECUTIVE_SUMMARY: "executiveSummary",
  // Auto accident liability is police-report driven and rendered as a single "Liability" section.
  LIABILITY_SINGLE: "liabilitySingle",
  LIABILITY_PER_DEFENDANT: "liabilityPerDefendantByDefendant",
  // Non-auto case types (premises / trip / slip / dog bite) build liability from these fields instead.
  FACTS_OF_INCIDENT_SINGLE: "factsOfIncidentSingle",
  FACTS_OF_INCIDENT_PER_DEFENDANT: "factsOfIncidentPerDefendantByDefendant",
  DANGEROUS_CONDITION_SINGLE: "dangerousConditionSingle",
  DANGEROUS_CONDITION_PER_DEFENDANT: "dangerousConditionPerDefendantByDefendant",
  ACTUAL_CONSTRUCTIVE_NOTICE_SINGLE: "actualConstructiveNoticeSingle",
  ACTUAL_CONSTRUCTIVE_NOTICE_PER_DEFENDANT: "actualConstructiveNoticePerDefendantByDefendant",
  MEDICAL_TREATMENT: "medicalTreatmentByClient",
  PRIOR_MEDICAL: "priorMedicalByClient",
  LIFECARE: "lifecareByClient",
  PAIN_AND_SUFFERING: "painAndSufferingByClient",
   // Lifecare types are split per-section and surfaced ONLY in the Lifecare Studio
  // (built by buildLifecareSectionDefinitions, not buildSectionDefinitions). The
  // Demand Studio no longer carries any lifecare section.
  LIFECARE_INFO: "lifecareInfoByClient",
  LIFECARE_DIAGNOSIS: "lifecareDiagnosisByClient",
  LIFECARE_LIFE_EXPECTANCY: "lifecareLifeExpectancyByClient",
  LIFECARE_SUMMARY_OF_RECORDS: "lifecareSummaryOfRecordsByClient",
  LIFECARE_FUTURE_CARE_NEEDS: "lifecareFutureCareNeedsByClient",
  // Summary tab is read-only (computed totals) and has no comment field.
  LIFECARE_SUMMARY: "lifecareSummary",
};

export const LIFECARE_TAB_TYPES = {
  INFO: "lifecareInfoByClient",
  DIAGNOSIS: "lifecareDiagnosisByClient",
  LIFE_EXPECTANCY: "lifecareLifeExpectancyByClient",
  SUMMARY_OF_RECORDS: "lifecareSummaryOfRecordsByClient",
  FUTURE_CARE_NEEDS: "lifecareFutureCareNeedsByClient",
  SUMMARY: "lifecareSummary",
};

// `commentField` is null for SUMMARY because totals are server-derived; there is
// nothing for a reviewer to instruct the LLM to change on that tab.
export const LIFECARE_TABS = [
  {
    key: "info",
    label: "Info",
    tabType: LIFECARE_TAB_TYPES.INFO,
    commentField: "lifecareInfoByClient",
  },
  {
    key: "diagnosis",
    label: "Diagnosis",
    tabType: LIFECARE_TAB_TYPES.DIAGNOSIS,
    commentField: "lifecareDiagnosisByClient",
  },
  {
    key: "lifeExpectancy",
    label: "Life Expectancy",
    tabType: LIFECARE_TAB_TYPES.LIFE_EXPECTANCY,
    commentField: "lifecareLifeExpectancyByClient",
  },
  {
    key: "summaryOfRecords",
    label: "Summary of Records",
    tabType: LIFECARE_TAB_TYPES.SUMMARY_OF_RECORDS,
    commentField: "lifecareSummaryOfRecordsByClient",
  },
  {
    key: "futureCareNeeds",
    label: "Future Care Needs",
    tabType: LIFECARE_TAB_TYPES.FUTURE_CARE_NEEDS,
    commentField: "lifecareFutureCareNeedsByClient",
  },
  {
    key: "summary",
    label: "Summary",
    tabType: LIFECARE_TAB_TYPES.SUMMARY,
    commentField: null,
  },
];

export const LIFECARE_COMMENT_FIELDS = LIFECARE_TABS
  .map((tab) => tab.commentField)
  .filter(Boolean);

export const LIFECARE_TAB_TYPE_VALUES = LIFECARE_TABS.map((tab) => tab.tabType);

export const LIFECARE_TAB_TYPE_TO_COMMENT_FIELD = Object.fromEntries(
  LIFECARE_TABS
    .filter((tab) => Boolean(tab.commentField))
    .map((tab) => [tab.tabType, tab.commentField])
);

export const getLifecareTabByType = (tabType) =>
  LIFECARE_TABS.find((tab) => tab.tabType === tabType) || null;

export const getLifecareTabByCommentField = (commentField) =>
  LIFECARE_TABS.find((tab) => tab.commentField === commentField) || null;

const HS_PRIORITIES ={
    HIGH: 'HIGH',
    LOW: 'LOW',
    MEDIUM: 'MEDIUM'
};

export const CERTIFIED_LIFECARE_SUPPORT_CATEGORY = 'Request Certified Life Care Plan';
export const CERTIFIED_LIFECARE_SUPPORT_COMMENT = 'The firm requested a Certified Life Care Plan. Please reach out to coordinate next steps.';

export const HELP_CATEGORIES_MAP = {
    TEMPLATE_CHANGE_REQUEST: { key: "TEMPLATE_CHANGE_REQUEST", value: "template_change_request", text: "Template Change Request", hsPipelineId: "0", stageId: "1", priority: HS_PRIORITIES.MEDIUM },
    BILLING: { key: "BILLING", value: "billing", text: "Billing", hsPipelineId: "904454918", stageId: "1368374871", priority: HS_PRIORITIES.HIGH },
    ISSUE_REPORT: { key: "ISSUE_REPORT", value: "issue_report", text: "Issue Report", hsPipelineId: "904387850", stageId: "1368371799", priority: HS_PRIORITIES.HIGH },
    FEATURE_REQUEST: { key: "FEATURE_REQUEST", value: "feature_request", text: "Feature Request", hsPipelineId: "904455829", stageId: "1368370845", priority: HS_PRIORITIES.LOW },
    FEEDBACK: { key: "FEEDBACK", value: "feedback", text: "Feedback", hsPipelineId: "904541981", stageId: "1368377768", priority: HS_PRIORITIES.LOW },
    OTHER: { key: "OTHER", value: "other", text: "Other", hsPipelineId: "907027874", stageId: "1373861476", priority: HS_PRIORITIES.LOW },
};

export const HELP_CATEGORY_PRIORITIES = Object.fromEntries(
    Object.values(HELP_CATEGORIES_MAP).map((category) => [category.value, category.priority])
);

export const HELP_CATEGORY_PIPELINE_IDS = Object.fromEntries(
    Object.values(HELP_CATEGORIES_MAP).map((category) => [category.value, category.hsPipelineId])
);

export const HELP_CATEGORY_STAGE_IDS = Object.fromEntries(
    Object.values(HELP_CATEGORIES_MAP).map((category) => [category.value, category.stageId])
);

export const HELP_CATEGORIES = Object.fromEntries(
    Object.entries(HELP_CATEGORIES_MAP).map(([k, v]) => [k, v.value])
);

export const COURT_LEVEL = {
    STATE: 'state',
    FEDERAL: 'federal'
}

export const DISCOVERY_TYPE_MAP = {
    FROG: { value: 'FROG', text: 'Form Interrogatory', shortLabel: 'FROG', responseField: 'FROGResponse', propoundField: 'FROGPropound', uploadField: 'FROGUpload' },
    SROG: { value: 'SROG', text: 'Special Interrogatory', shortLabel: 'SROG', responseField: 'SROGResponse', propoundField: 'SROGPropound', uploadField: 'SROGUpload' },
    DOCUMENT: { value: 'DOCUMENT', text: 'Request for Production', shortLabel: 'RFP', responseField: 'DOCUMENTResponse', propoundField: 'DOCUMENTPropound', uploadField: 'DOCUMENTUpload' },
    ADMISSION: { value: 'ADMISSION', text: 'Request for Admission', shortLabel: 'RFA', responseField: 'ADMISSIONResponse', propoundField: 'ADMISSIONPropound', uploadField: 'ADMISSIONUpload' }
}

export const DISCOVERY_UPLOAD_FIELD_BY_TYPE = Object.fromEntries(
    Object.values(DISCOVERY_TYPE_MAP).map((entry) => [entry.value, entry.uploadField])
);

export const VALID_DISCOVERY_UPLOAD_TYPES = Object.keys(DISCOVERY_UPLOAD_FIELD_BY_TYPE);

export const DISCOVERY_TYPE = Object.fromEntries(
    Object.entries(DISCOVERY_TYPE_MAP).map(([key, entry]) => [key, entry.value])
);

export const getDiscoveryTypeMeta = (value) => DISCOVERY_TYPE_MAP[value] ?? null;

export const DISCOVERY_PREFERENCE_TYPES = [DISCOVERY_TYPE.SROG, DISCOVERY_TYPE.DOCUMENT, DISCOVERY_TYPE.ADMISSION];

export const DISCOVERY_PREFERENCE_UPLOAD_TEXT = 'Upload examples of your propounding documents for this case type to establish a baseline.';

export const QUERY_BOOL_MAP = { true: true, false: false };

export const DISCOVERY_TEMPLATE_DEFAULT_STATE = ['California'];

export const discoveryPropoundStaticFile = ({ state, discoveryType = DISCOVERY_TYPE.FROG }) => {
    const normalizedState = (state || DISCOVERY_TEMPLATE_DEFAULT_STATE[0]).toLowerCase();
    return `discovery/staticFiles/${normalizedState}/propound/${discoveryType}.pdf`;
};

// how the checked boxes on an uploaded FROG were read, since flattened uploads lose their AcroForm widgets.
// the handlers form a chain of responsibility: each decides whether it can read an upload, or passes it on
export const FROG_DETECTION_HANDLER = {
    ACROFORM: 'ACROFORM',
    DIFFERENTIAL_INK: 'DIFFERENTIAL_INK',
    TEXTRACT_FORMS: 'TEXTRACT_FORMS'
};

// whitelist of file fields the discovery-set upload/delete endpoints are allowed to touch
export const VALID_DISCOVERY_FIELD_NAMES = Object.values(DISCOVERY_TYPE_MAP)
    .flatMap((entry) => [entry.responseField, entry.propoundField]);

export const PreliminaryStatementLevel = {
  DiscoverySet: 'DiscoverySet',
  Discovery: 'Discovery',
  App: 'App',
};

export const PreliminaryStatementLevelTooltips = {
    [PreliminaryStatementLevel.Discovery]: "Sets the statement for all discovery sets.",
    [PreliminaryStatementLevel.DiscoverySet]: "Sets the statement only for this discovery set.",
};

export const DISCOVERY_QUESTION_EDITABLE_FIELDS = [
    'aiObjections',
    'aiResponse',
    'aiObjectionAccepted',
    'aiResponseAccepted',
    'bankedObjections',
    'userResponse'
];

export const DISCOVERY_OBJECTION_GROUP_MAP = {
  PRELIMINARY_ISSUES: { text: 'Preliminary Issues', value: 'PRELIMINARY_ISSUES' },
  RELEVANCE_FORM_SCOPE: { text: 'Relevance, Form & Scope', value: 'RELEVANCE_FORM_SCOPE' },
  WORK_PRODUCT_STATEMENTS_EXPERTS: { text: 'Work Product, Statements & Experts', value: 'WORK_PRODUCT_STATEMENTS_EXPERTS' },
  MEDICAL_COLLATERAL_SOURCE: { text: 'Medical & Collateral Source', value: 'MEDICAL_COLLATERAL_SOURCE' },
  LOST_INCOME_TAX_RECORDS: { text: 'Lost Income & Tax Records', value: 'LOST_INCOME_TAX_RECORDS' },
  PHOTOS_REPAIR_BILLS: { text: 'Photos, Repair Bills, Etc.', value: 'PHOTOS_REPAIR_BILLS' },
  OTHER_MISC_REQUESTS: { text: 'Other Misc Requests', value: 'OTHER_MISC_REQUESTS' },
  GENERAL_OBJECTIONS: { text: 'General Objections', value: 'GENERAL_OBJECTIONS' },
  IMPROPER_TIMING: { text: 'Improper Timing', value: 'IMPROPER_TIMING' },
  CUSTOM_OBJECTIONS : { text: 'Custom Objections', value: 'CUSTOM_OBJECTIONS' }
};

export const DISCOVERY_OBJECTION_GROUP= Object.fromEntries(
    Object.entries(DISCOVERY_OBJECTION_GROUP_MAP).map(([key, entry]) => [key, entry.value])
);

const AUTOSAVE_IDLE = 'idle';
const AUTOSAVE_SAVING = 'saving';
const AUTOSAVE_SAVED = 'saved';
const AUTOSAVE_FAILED = 'failed';

export const AUTOSAVE_STATUS = {
  IDLE: AUTOSAVE_IDLE,
  SAVING: AUTOSAVE_SAVING,
  SAVED: AUTOSAVE_SAVED,
  FAILED: AUTOSAVE_FAILED,
};

// The values Classic Intake's gender select offers, exactly as Constants.Dropdowns.MrMrs writes them.
// The agent has to emit one of these verbatim or the select renders blank on the edit screen, and the
// letter's pronoun instruction falls back to a masculine default. Distinct from GENDER above, which is
// the lowercase silent-witness occupant vocabulary persisted by CreateRequestSchema.
export const INTAKE_GENDER = {
  MALE: 'Male',
  FEMALE: 'Female',
  OTHER: 'Other'
};

// The pain and suffering checkboxes, which are a closed vocabulary: a box is checked only when
// selectedPainPoints holds the option's exact string. Lives here rather than in the UI because the
// virtual user agent has to select from the same list a human ticks, and a second copy would drift.
export const PAIN_POINT_CATEGORIES = [
  {
    category: 'Personal Care',
    points: ['Self Bathing', 'Self Dressing', 'Self Grooming', 'Putting on Shoes']
  },
  {
    category: 'Fitness and Recreation',
    points: ['Walking', 'Running', 'Going to the Gym', 'Youth Sports']
  },
  {
    category: 'Leisure and Rest',
    points: ['Sleep', 'Sex Life', 'Family Vacations']
  },
  {
    category: 'Household Tasks',
    points: [
      'Cleaning',
      'Dishes',
      'Laundry',
      'Taking Out Trash',
      'Raking Leaves / Shoveling Snow',
      'Yardwork',
      'Car Maintenance',
      'Grocery Shopping',
      'Gardening'
    ]
  },
  {
    category: 'Family and Relationships',
    points: [
      'Relationship with Spouse',
      'Relationship with Children',
      'Relationship with Grandchildren',
      'Holding Children',
      'Family Play Time',
      'Family Outings'
    ]
  }
];

export const ALL_PAIN_POINTS = PAIN_POINT_CATEGORIES.flatMap(({ points }) => points);

/**
 * Reports whether a value is one of the pain and suffering checkboxes.
 * @param {string} [painPoint] - a candidate selectedPainPoints entry
 * @returns {boolean}
 */
export const getIsKnownPainPoint = (painPoint) => ALL_PAIN_POINTS.includes(painPoint);

// Guided product tours. Doubles as the key under a user's onboarding record.
export const TOUR_IDS = {
  EDIT_CASE: 'editCase',
  CASE_LIST: 'caseList',
  DASHBOARD: 'dashboard',
  DEMAND_STUDIO: 'demandStudio',
  EASY_MODE: 'easyMode',
};

export const TOUR_ID_VALUES = Object.values(TOUR_IDS);

// Both COMPLETED and DISMISSED end a tour, but only a dismissal tells us the
// user bailed out. REFRESHER_OFFERED does not end anything: it records that a
// returning user was already asked, so the offer is made once per absence
export const TOUR_STATE = {
  COMPLETED: 'completedAt',
  DISMISSED: 'dismissedAt',
  REFRESHER_OFFERED: 'refresherOfferedAt',
};

export const TOUR_STATE_VALUES = Object.values(TOUR_STATE);
